import { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const PHASES = [
  { tag: "Today", eyebrow: "The Commercial Foundation · Safe Band Pro", head: "Available today.", accent: null },
  { tag: "Tomorrow", eyebrow: "The Intelligent Layer · In Development", head: "Built to expand.", accent: "expand." },
];

export function AvailableTodayBanner() {
  const [phase, setPhase] = useState(0);
  const bandRef = useRef(null);

  useEffect(() => {
    const band = bandRef.current;
    if (band) band.play().catch(() => {});
    const t = setTimeout(() => setPhase((p) => (p === 0 ? 1 : 0)), phase === 0 ? 4600 : 4600);
    return () => clearTimeout(t);
  }, [phase]);

  const p = PHASES[phase];

  return (
    <div className="relative w-full overflow-hidden h-[70vh] md:h-[95vh]" data-testid="home-availabletoday-banner">
      <div className="absolute inset-0 radial-glow scale-150" />

      {/* Quick-dispense demo: the reservoir face pressed and dispensing, plays on its own */}
      <video
        ref={bandRef}
        src="/prototype/quick-dispense.mp4"
        poster="/prototype/quick-dispense-poster.jpg"
        autoPlay
        muted
        playsInline
        loop
        data-testid="home-safeband-video"
        className="absolute inset-0 w-full h-full object-cover"
      />

      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent pointer-events-none" />

      <div className="absolute inset-0 flex items-end">
        <div className="max-w-7xl mx-auto px-6 md:px-12 w-full pb-8 md:pb-12">
          {/* Today / Tomorrow toggle chips */}
          <div className="flex items-center gap-2.5 mb-5" data-testid="home-todaytomorrow-chips">
            {PHASES.map((ph, i) => (
              <span
                key={ph.tag}
                className="font-mono text-[10px] tracking-[0.2em] uppercase px-3 py-1.5 rounded-full border transition-all duration-500"
                style={
                  i === phase
                    ? { color: "#050505", background: i === 0 ? "#00e5ff" : "#ff2d78", borderColor: "transparent" }
                    : { color: "#71717a", borderColor: "#3f3f46" }
                }
              >
                {ph.tag}
              </span>
            ))}
          </div>

          <AnimatePresence mode="wait">
            <motion.div
              key={phase}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -14 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
              <p className="font-mono text-xs tracking-[0.25em] uppercase text-accent mb-4">{p.eyebrow}</p>
              <h2
                className="font-heading text-4xl sm:text-5xl md:text-6xl font-light tracking-tighter leading-[1.02] text-white"
                style={{ textShadow: "0 2px 26px rgba(0,0,0,0.7)" }}
              >
                {p.accent ? (
                  <>
                    {p.head.replace(p.accent, "")}
                    <span style={{ color: "#ff2d78" }}>{p.accent}</span>
                  </>
                ) : (
                  p.head
                )}
              </h2>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}
